import {Message, MessageBox} from 'element-ui'

export const asyncAjax = (api, ...params) => {
    return api(...params).then(res => {
        return [res, null]
    }).catch(err => {
        return [null, err]
    });
}

export const openError = message => {
    Message.error(message);
    throw message;
}

export const getParams = (config) => {
    let _params = {};
    config.forEach(item => {
        let _key = item.key;
        let _value = item.value;
        if (item.key && ('value' in item) && !_value && !item.notRequired && !item.notParam) {
            openError(`${item.title}为必填项`);
        }
        if (item.key && !item.notParam && _value !== '') {
            if (item.compose) {
                const _datas = item.compose();
                if (_datas.error) {
                    openError(_datas.error);
                }
                _params = {..._params, ..._datas}
            } else {
                _params[_key] = _value;
            }
        }
    })
    return _params
}

export const getHeaderData = (listConfig) => {
    const header_data = {};
    listConfig.map(item => {
        header_data[item.title] = item.showData ? {key: item.key, showData: item.showData} : item.key
    })
    return header_data
}

export function openMessageBox(options, callBack) {
    MessageBox.confirm(options.content, options.title || '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: options.confirm || '确定',
        cancelButtonText: options.cancel || '取消',
        closeOnClickModal: false
    }).then(() => callBack(true)).catch(action => action === 'cancel' && callBack(false))
}